<template>
  <div
    class="recipients"
  >
    <div v-if="sendingCandidates.length === 1" class="one-candidate">
      <label>
        {{ $tr('responses.sendingCandidate') }}
        {{ full_name }}
      </label>
    </div>
    <template v-else-if="sendingCandidates.length > 1">
      <label>{{ $tr('responses.sendingCandidates') }}</label>
      <ul>
        <li
          v-for="candidate in slicedCandidates"
          :key="candidate.id"
        >
          {{ [candidate.name, candidate.surname].join(' ') }}
          <i class="icon icon-close" @click="deteteFromShare(candidate.id)"></i>
        </li>
        <span
          v-if="!showAllCandidates && showHint"
          class="show-more"
          @click="showAllCandidates = !showAllCandidates"
        >
          {{ showMoreHint }}
        </span>
      </ul>
      <span
        v-if="showAllCandidates && showHint"
        class="show-more"
        @click="showAllCandidates = !showAllCandidates"
      >
        {{ showMoreHint }}
      </span>
    </template>
  </div>
</template>

<script>
  import Pluralize from '@/mixins/pluralize'

  const MAX_SHOW_CANDIDATES = 4

  export default {
    props: {
      deteteFromShare: {
        type: Function,
        required: true
      },
      sendingCandidates: {
        type: Array,
        required: true
      }
    },

    mixins: [
      Pluralize
    ],

    data () {
      return {
        showAllCandidates: false,
        MAX_SHOW_CANDIDATES: MAX_SHOW_CANDIDATES
      }
    },

    computed: {
      is_japan_locale() {
        return this.$store.getters['locale/is_japan_locale'];
      },

      full_name() {
        const candidate = this.sendingCandidates[0];

        return !this.is_japan_locale ? [candidate.name, candidate.surname].join(' ') : [candidate.surname, candidate.name].join(' ')
      },

      showMoreHint () {
        if (this.showAllCandidates) {
          return this.$tr('responses.hideOtherCandidates')
        } else {
          const andOther = this.$tr('responses.andOtherCandidates')

          const c = this.sendingCandidates.length - MAX_SHOW_CANDIDATES

          const pluralized = this.pluralize(this.$tr('responses.candidate'), c)

          return `${andOther} ${c} ${pluralized}`
        }
      },

      showHint () {
        return this.sendingCandidates.length > MAX_SHOW_CANDIDATES
      },

      slicedCandidates () {
        return this.showAllCandidates
          ? this.sendingCandidates
          : this.sendingCandidates.slice(0, MAX_SHOW_CANDIDATES)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .recipients {
    margin-bottom: 23px;

    label {
      font-weight: 600;
      line-height: 21px;
      font-size: 16px;
      margin-bottom: 5px;
    }

    .one-candidate { display: flex; }

    ul {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      // Max - 3 lines
      max-height: 87px;
      overflow-y: auto;

      li {
        list-style: none;
        background: #E9E9E9;
        border-radius: 4px;
        padding: 4px 7px;
        white-space: nowrap;
        margin-bottom: 5px;
        margin-right: 5px;
      }

      .show-more { margin-left: 14px; }
    }

    .show-more {
      font-size: 13px;
      text-decoration-line: underline;
      color: #3EAF29;
      cursor: pointer;
    }

  }
</style>
